import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  alphaListFetchingInnerCorrelationSelector,
  alphaListInnerCorrelationDataInnerSelector,
} from '../../../reducers/AlphaListsReducer/AlphaListsSelector';
import { mapOrder } from '../../../shared/helpers';

import './InnerCorrelation.scss';
import InnerCorrelationMain from './InnerCorrelationMain';

interface InnerCorrelationContainerProps {
  alphasInfo: any;
}

const InnerCorrelationContainer = (props: InnerCorrelationContainerProps) => {
  const { alphasInfo } = props;
  // @ts-ignore
  const innerCorrelationTable: any = useSelector(alphaListInnerCorrelationDataInnerSelector);
  // @ts-ignore
  const isFetchingInnerCorrelation: boolean = useSelector(alphaListFetchingInnerCorrelationSelector);

  const getTableData = () => {
    const indexOfId =
      innerCorrelationTable &&
      innerCorrelationTable.getIn(['schema', 'properties']).findIndex((property: any) => property.get('name') === 'id');
    const newInnerCorrelation =
      alphasInfo &&
      innerCorrelationTable &&
      alphasInfo.map((alpha: any) =>
        innerCorrelationTable.getIn(['schema', 'properties']).findIndex((property: any) => property.get('name') === alpha.id)
      );
    const innerData =
      innerCorrelationTable &&
      alphasInfo &&
      alphasInfo.map((alpha: any) => {
        const alphaCorrelationData = innerCorrelationTable
          .get('records')
          .toJS()
          .find((data: any) => alpha.id === data[indexOfId]);

        return {
          id: alpha.id,
          color: alpha.color,
          text: alpha.text,
          data: alphaCorrelationData
            ? alphaCorrelationData.filter((_: any, index: number) => index !== indexOfId && newInnerCorrelation.indexOf(index) !== -1)
            : [],
          ascSort: false,
          descSort: false,
        };
      });

    const order =
      innerCorrelationTable &&
      innerCorrelationTable
        .getIn(['schema', 'properties'])
        .slice(1)
        .map((property: any) => property.get('name'));

    return innerData && order ? mapOrder(innerData, order, 'id') : null;
  };

  const innerTableData = getTableData();

  return alphasInfo && !isFetchingInnerCorrelation ? <InnerCorrelationMain innerCorrelationTable={innerTableData} /> : <div />;
};

export default InnerCorrelationContainer;
